var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.196801 33.8399L28.282 1.22158C29.0934 0.221785 31.0906 -1.10294 32.5885 1.59651L36.3331 17.1558L44.946 11.9069C46.1318 11.407 48.3911 11.1196 47.9417 13.969L43.4481 28.7785C42.824 30.1532 41.0515 32.0778 38.9544 28.7785L36.3331 17.1558L3.00533 37.0268C1.69468 37.3392 -0.701927 37.1393 0.196801 33.8399Z",
    fill: "url(#paint0_linear_872_9077)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_9077",
    x1: 5.99152,
    y1: 32.2434,
    x2: 35.2717,
    y2: -0.663778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D1DF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4cd72e9997de98767ec249f169e6c23.svg";
export { ForwardRef as ReactComponent };